import { gql } from '@apollo/client';
export const query = gql `
  query composersCount($companyId: UUID!, $currentPlanId: UUID!, $marketLocaleCodes: [String!]!) {
    all: aggregateComposer(
      where: {
        enabled: { _eq: true }
        templates: { market_locale_code: { _in: $marketLocaleCodes } }
      }
    ) {
      aggregate {
        count
      }
    }

    included: aggregateComposer(
      where: {
        enabled: { _eq: true }
        templates: { market_locale_code: { _in: $marketLocaleCodes } }
        available_for_plans: { id: { _eq: $currentPlanId } }
      }
    ) {
      aggregate {
        count
      }
    }

    company: aggregateComposer(
      where: {
        enabled: { _eq: true }
        templates: { market_locale_code: { _in: $marketLocaleCodes } }
        company_composers: { company_id: { _eq: $companyId } }
      }
    ) {
      aggregate {
        count
      }
    }
  }
`;
